import React from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css";
import "./styles/carousel.css";

import dumbarton from "../images/carousel/dumbarton_rd_slushee.webp";
import autoport from "../images/carousel/autoport_slushee.webp";
import strathclyde from "../images/carousel/strathclyde_slush.webp";
import crowwood from "../images/carousel/crowwood_slushee.webp";

const images = [dumbarton, autoport, strathclyde, crowwood];

export default function Carousel2() {
  return (
    <div className="tubbees-orbit" aria-label="Tubbees drinks">
      <div className="tubbees-orbit-arc" aria-hidden="true" />
      <div className="tubbees-orbit-arc-inner" aria-hidden="true" />
      <div className="tubbees-orbit-stage">
        <Splide
          className="tubbees-splide"
          extensions={{ AutoScroll }}
          options={{
            type: "loop",
            arrows: false,
            pagination: false,
            drag: true,
            focus: "center",
            gap: "1.25rem",
            perPage: 3,
            autoScroll: {
              pauseOnHover: false,
              pauseOnFocus: false,
              speed: 0.8,
            },
          }}
        >
          {images.map((image, index) => (
            <SplideSlide key={`${image}-${index}`}>
              <div className="tubbees-orbit-card">
                <div className="tubbees-orbit-image">
                  <img src={image} alt="" draggable="false" />
                </div>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </div>
  );
}
